import { fetchAllPropertyValues } from './api';
import { Metrics } from '../metrics/Metrics';
export class PropertyValuesCache {
  constructor() {
    this.cache = {};
  }

  get({
    objectId,
    objectTypeId,
    httpClient,
    skip = false
  }) {
    const cachedPromise = this.cache[objectTypeId] && this.cache[objectTypeId][objectId];

    if (cachedPromise) {
      return cachedPromise;
    }

    let promise;

    if (skip) {
      // if portal is not ungated for on-demand value fetching, skip the actual fetch
      promise = Promise.resolve({});
    } else {
      Metrics.counter('fetch-all-values-on-demand', {
        objectTypeId
      }).increment();
      promise = fetchAllPropertyValues(objectId, objectTypeId, httpClient).then(res => Object.entries(res.properties).reduce((acc, [name, property]) => {
        acc[name] = property.value;
        return acc;
      }, {}));
    }

    if (!this.cache[objectTypeId]) {
      this.cache[objectTypeId] = {};
    }

    this.cache[objectTypeId][objectId] = promise;
    return promise;
  }

  clear() {
    this.cache = {};
  }

}